export default __webpack_public_path__ + "static/media/auth-decoration (1).bda4f61c.png";